module.exports = __webpack_public_path__ + "d1dae8f4a814e5cee66d3a045c0a38e5.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/dataset-control.png
// module id = 2411
// module chunks = 0